import { Box, SxProps, useMediaQuery, useTheme } from "@mui/material";
import { ReactNode } from "react";

import styles from "./Content.module.css";

export interface IContentProps {
    children: ReactNode;
    dataTestIdSuffix: string;
    sx?: SxProps;
}

export default function Content({ children, dataTestIdSuffix, sx }: IContentProps) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const childrenStyles = isMobile
        ? { width: "100%", maxWidth: "100%", overflow: "hidden" }
        : { maxWidth: theme.breakpoints.values.md, width: "100%", justifySelf: "center" };

    return (
        <Box className={styles.content} data-test-id="section_content">
            <Box sx={{ ...childrenStyles, ...sx }} data-test-id={`section_page_${dataTestIdSuffix}`}>
                {children}
            </Box>
        </Box>
    );
}
